export default __webpack_public_path__ + "static/media/18979741171_ccafc3c7ff_b.4cdc2496.jpg";